import {Component, OnInit} from '@angular/core';
import {ZkService} from '../../../services/zk.service';
import {OfficeService} from '../../../services/office.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Office} from '../../../classes/Office';
import {ZkRtData} from '../../../classes/zk/ZkRtData';
import {ngxLoadingAnimationTypes} from 'ngx-loading';
import {ZkRtLog} from "../../../classes/zk/ZkRtLog";
import {Page} from "../../../classes/Page";

@Component({
  selector: 'app-zk-rt-log',
  styleUrls: ['./zk-rt-log.component.scss'],
  templateUrl: './zk-rt-log.component.html',
})
export class ZkRtLogComponent implements OnInit {

  public rtLogs: ZkRtLog[];
  public loading = false;
  public errorMessage: string;
  public offices: Office[];
  public officesForm: FormGroup;
  public currentOfficeId: number;
  public primaryColour = '#ffffff';
  public secondaryColour = '#ccc';
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public pageNumber = 1;
  public totalElements = 0;
  public pageSizes = [10, 20, 50];
  public pageSize = this.pageSizes[0];

  constructor(private zkService: ZkService,
              private officeService: OfficeService,
              private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.officeService.getAll().subscribe(response => this.offices = response);

    this.officesForm = this.formBuilder.group({
      officeId: [null, Validators.required]
    });

    this.officesForm.controls.officeId.valueChanges.subscribe((officeId) => {
      this.currentOfficeId = officeId;
      this.refreshList();
    });
  }

  refreshList(): void {
    this.loading = true;
    this.zkService.getRtLog(this.currentOfficeId, this.pageNumber - 1, this.pageSize).subscribe({
      next: (response: Page<ZkRtLog>) => {
        this.rtLogs = response.content;
        this.totalElements = response.totalElements;
      },
      error: (error) => {
        this.errorMessage = error.error.error;
      },
      complete: () => this.loading = false
    });
  }

  handlePageChange(event): void {
    this.pageNumber = event;
    this.refreshList();
  }

  handlePageSizeChange(event): void {
    this.pageSize = event.target.value;
    this.pageNumber = 1;
    this.refreshList();
  }

  getMinLimit(): number {
    return this.pageSize * (this.pageNumber - 1) + 1;
  }

  getMaxLimit(): number {
    const maxLimit = this.pageSize * this.pageNumber;
    return maxLimit <= this.totalElements ? maxLimit : this.totalElements;
  }

}
